export const DEFAULT_HELP_LANGUAGE = "en";
export const SUPPORTED_HELP_LANGUAGES = ["en", "ru"] as const;

export type HelpLanguage = (typeof SUPPORTED_HELP_LANGUAGES)[number];

const supportedHelpLanguages = new Set<string>(SUPPORTED_HELP_LANGUAGES);

export const resolveHelpLanguage = (language?: string | null): HelpLanguage => {
  const normalizedLanguage = language?.toLowerCase().split("-")[0];

  if (normalizedLanguage && supportedHelpLanguages.has(normalizedLanguage)) {
    return normalizedLanguage as HelpLanguage;
  }

  return DEFAULT_HELP_LANGUAGE;
};
